import { useEffect, useId } from 'react';

import { useAppShellActions } from '@/data/context/AppShellContext';

export default function useShellBackHref(href?: string) {
  const ownerId = useId();
  const { setBackTarget } = useAppShellActions();

  useEffect(() => {
    if (!href) return;

    setBackTarget({ ownerId, href });

    return () =>
      setBackTarget(current =>
        current?.ownerId === ownerId ? undefined : current,
      );
  }, [setBackTarget, ownerId, href]);
}
